import React, { ComponentPropsWithRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { Typography } from '@mui/material'
import { Icons } from '../assets/icons'
import IconButton from '@mui/material/IconButton'

interface Props extends ComponentPropsWithRef<'button'> {
    title?: string
}
export const BurgerButton = (p: Props) => {
    const { className, onClick, ...rest } = p
    return (
        <IconButton
            {...rest}
            className={twMerge('p-5', className)}
            onClick={onClick}
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
        >
            {p.title && <Typography variant="h6">{p.title}</Typography>}
            <Icons.MenuIcon />
        </IconButton>
    )
}
